import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { formsService } from '../api/forms.service';
import { SUBMISSION_KEYS } from './queryKeys';
import type { SubmitFormPayload } from '../types';

/**
 * Works both for authenticated org members and anonymous public visitors —
 * `POST /forms/{id}/submit` is `AllowAnonymous` and skips tenant verification.
 * When there is no active organization (anonymous flow), nothing is invalidated.
 */
export function useSubmitForm(formId: string) {
  const queryClient = useQueryClient();
  const orgId = useOrganizationStore((s) => s.activeOrganizationId);

  return useMutation({
    mutationFn: (data: SubmitFormPayload) => formsService.submit(formId, data),
    onSuccess: () => {
      if (!orgId) return;
      queryClient.invalidateQueries({ queryKey: SUBMISSION_KEYS.byForm(orgId, formId) });
    },
  });
}
